<template>
  <div>
    <div class="title-and-choice">
      <!-- 标题 -->
      <span class="title">{{title}}</span>
      <!-- 按钮 -->
      <el-link class="choice-button-style"
               v-if="choice_visable_prop"
               @click="cancleBandTemplate"
               :underline="false"
               style="float:right; padding-left:5px"
               type="info"
               icon="el-icon-sort">取消关联</el-link>
      <el-link class="choice-button-style"
               v-if="choice_visable_prop"
               @click="choiceButtonClick"
               :underline="false"
               style="float:right; padding-left:5px"
               type="info"
               icon="el-icon-sort">修改</el-link>

      <el-link class="save-button-style"
               v-if="save_visable_prop"
               @click="cancleButtonClick"
               :underline="false"
               style="padding-left:5px"
               type="info">取消</el-link>

      <el-link class="save-button-style"
               v-if="save_visable_prop"
               @click="saveButtonClick"
               :underline="false"
               type="info"
               icon="el-icon-folder-checked">保存</el-link>

      <!-- 内容展示 -->
      <div>
        <div v-if="show_content_visable_prop"
             class="choice_template_area">
          <!--如果为空，则显示 未绑定模版 -->
          <div v-if="this.content ==''">未绑定预定信息模版</div>
          <!--否则，则显示模版内容 -->
          <div v-else>
            <div style="display:inline">当前模版为：</div>
            <div style="display:inline"
                 class="info-list-item-stype"
                 v-for="(item,index) of content"
                 :key="index">{{item.name}}</div>
          </div>
        </div>

        <!-- 选择器 -->
        <div class="input">
          <!-- 对话框 -->
          <div v-if="show_input_prop"
               :class="{class_name_one:false,class_name_two:true}">
            <el-table :data="templateData">
              <el-table-column width="40%">
                <template slot-scope="scope">
                  <el-radio-group v-model="choicedTemplate">
                    <el-radio @change="checkedboxChange"
                              :label="scope.row.id">
                      <span></span>
                    </el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="id"
                               label="模版编号"
                               width="80px"></el-table-column>
              <el-table-column prop="template_name"
                               label="模版名称"
                               width="150%"></el-table-column>
              <el-table-column prop="template"
                               label="模版内容">
                <template slot-scope="scope">
                  <div class="info-list-item-stype"
                       v-for="(item,index) of scope.row.template"
                       :key="index">{{item}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '..//editor/editorV1'
export default {
  name: 'band-res-template',
  components: {
    'editor-area': Editor,
  },
  data() {
    return {
      info: '',
      is_editor: '',
      choicedTemplate: this.checkBox,
      choice_visable_prop: this.edit_visable,
      save_visable_prop: this.save_visable,
      show_input_prop: this.show_editor,
      show_content_visable_prop: this.show_content_visable,
      // 输入组件
      input_textarea_width: '300px',
      input_text: this.input_text_content,
      input_textares: '',
      content: this.res_template_checked,
    }
  },
  watch: {
    res_template_checked: {
      handler(newValue, oldValue) {
        this.content = newValue
      },
      immediate: true,
    },
    checkBox: {
      handler(newValue, oldValue) {
        this.choicedTemplate = newValue
      },
      immediate: true,
    },
  },
  props: {
    title: String,
    res_template_checked: Array, //动态绑定
    templateData: Array, //列表数据
    input_textares_width: String,
    checkBox: Number,
    sku_id: Number,
    // 样式
    // input_width: String,
    type: String,
    edit_visable: {
      type: Boolean,
      default: true,
    },
    save_visable: {
      type: Boolean,
      default: false,
    },
    show_editor: {
      type: Boolean,
      default: false,
    },
    show_content_visable: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event.target.innerHTML);
      this.$copyText(event.target.innerHTML).then((res) => {
        this.$message({
          message: '信息已复制到剪贴板',
          type: 'success',
        })
      })
    },

    // 点击 修改 时的 方法
    choiceButtonClick() {
      this.save_visable_prop = true
      this.choice_visable_prop = false
      this.show_input_prop = true
      this.show_content_visable_prop = false
      this.editor_content = this.show_content
      //   console.log("编辑" + this.editor_content);
      //   this.$emit("change",this.)
      this.$emit('selectResTemplate')
      //  将点击的修改事件传到外面
    },
    // 取消关联
    cancleBandTemplate() {
      this.$http
        .get(`/product/cancel_band_reservation_stencil?sku_id=${this.sku_id}`)
        .then((res) => {
          const { data, errno, errmsg } = res.data
          if (errno == '0') {
            // 赋值组件的数据
            this.$notify.error({
              title: '完成',
              message: errmsg,
              type: 'success',
            })
          } else if (errno == '4001') {
          } else if (errno == '4002') {
            // 赋值组件数据内容为空
            this.res_template_checked = []
          } else if (errno == '4103') {
            this.$notify.error({
              title: '错误',
              message: errmsg,
            })
          }
        })
    },
    // 点击保存按钮时
    saveButtonClick() {
      if (this.choicedTemplate == null) {
        this.$notify.error({
          title: '错误',
          message: '未选择需要绑定的模版',
        })
      } else {
        this.$http
          .get(
            `/product/band_reservation_stencil?sku_id=${this.sku_id}&template_id=${this.choicedTemplate}`
          )
          .then((res) => {
            const { data, errno, errmsg } = res.data
            if (errno == '0') {
              // 获取模版内容，修改数据
              this.$http
                .get(`/get_reservation_stencil?id=${this.choicedTemplate}`)
                .then((res) => {
                  const { data, errno, errmsg } = res.data
                  if (errno == '0') {
                    // 赋值组件的数据
                    let newData = new Function('return' + data[0].template)()
                    this.content = newData
                  } else if (errno == '4001') {
                  } else if (errno == '4002') {
                    // 赋值组件数据内容为空
                    this.res_template_checked = []
                  } else if (errno == '4103') {
                    this.$notify.error({
                      title: '错误',
                      message: errmsg,
                    })
                  }
                })
              // 关闭显示
              this.save_visable_prop = false
              this.choice_visable_prop = true
              this.show_input_prop = false
              this.show_content_visable_prop = true
              this.$notify({
                title: '成功',
                message: errmsg,
                type: 'success',
              })
            } else if (errno == '4002' || errno == '4103' || errno == '4004') {
              this.$notify.error({
                title: '错误',
                message: errmsg,
              })
            }
          })
      }

      // console.log(this.input_text);
      let sku_id = this.$emit('save', this.input_text, this.checkBox)
    },
    // 取消编辑
    cancleButtonClick() {
      this.save_visable_prop = false
      this.choice_visable_prop = true
      this.show_input_prop = false
      this.show_content_visable_prop = true
    },
    // 监听选项改变值
    checkedboxChange() {
      console.log(this.choicedTemplate)
    },
  },
}
</script>

<style>
.title-and-choice:hover .choice-button-style {
  display: inline;
}
.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}
.choice_template_area {
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
}
.editor {
  margin-top: 10px;
}
.choice-button-style {
  display: none;
  font-size: 10px;
}
.save-button-style {
  font-size: 10px;
}
/* v-bind 绑定两种class */
.class_name_one {
  width: 100px;
}
.class_name_two {
  width: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid whitesmoke;
}
.info-list-item-stype {
  display: inline;
  color: white;
  margin-right: 5px;
  padding: 10px;
  background-color: #ff5421;
}
</style>